import $http from '@/libs/axios'

class CouponAPIs {
  static async verify(code: string, current_package: string, target_package: string, branch_id: number) {
    return (await $http.post('/coupons/verify', {
      code, current_package, target_package, branch_id,
    })).data
  }
}

export default CouponAPIs
